const RINGTONE_FILES = {
  default: "default.mp3",
  beezle: "beezle.mp3",
  ding: "ding.mp3",
  beep: "beep.mp3",
  bell: "bell.mp3",
  clock: "clock.mp3",
  popup: "popup.mp3",
};

const RINGTONE_LABELS = {
  default: "Chime (default)",
  beezle: "Double Chime",
  ding: "Ding",
  beep: "Beep",
  bell: "Bell",
  clock: "Clock",
  popup: "Popup",
};

export const RINGTONE_OPTIONS = Object.keys(RINGTONE_FILES).map(key => ({
  text: RINGTONE_LABELS[key] || key.charAt(0).toUpperCase() + key.slice(1),
  value: key
}));

let currentAudio = null;
let lastPlayedAt = 0;
const COOLDOWN_MS = 1000;

export function playNotificationSound(ringtone = "default", skipCooldown = false) {
  const now = Date.now();
  if (!skipCooldown && now - lastPlayedAt < COOLDOWN_MS) return;
  if (!skipCooldown) lastPlayedAt = now;

  const file = RINGTONE_FILES[ringtone] || RINGTONE_FILES.default;

  if (currentAudio) {
    currentAudio.onerror = null;
    currentAudio.onended = null;
    currentAudio.pause();
    currentAudio.removeAttribute("src");
    currentAudio.load();
  }

  const audio = new Audio(`/sounds/${file}`);
  currentAudio = audio;
  audio.onended = () => {
    if (currentAudio === audio) currentAudio = null;
  };
  audio.onerror = () => {
    if (currentAudio === audio) currentAudio = null;
  };
  audio.play().catch(() => {});
}
